import { ApplicationConfig, ErrorHandler, importProvidersFrom, Injectable, LOCALE_ID, Provider } from "@angular/core"
import { registerLocaleData } from "@angular/common"
import { provideHttpClient } from "@angular/common/http"
import localeDe from "@angular/common/locales/de"
import { PreloadAllModules, provideRouter, RouteReuseStrategy, withPreloading } from "@angular/router"
import { ServiceWorkerModule } from "@angular/service-worker"
import { IonicModule, IonicRouteStrategy, Platform } from "@ionic/angular"
import * as sentry from "@sentry/angular"
import { environment } from "../environments/environment"
import { getUserId } from "./app.tools"
import { routes } from "./app.routes"


// Locale
registerLocaleData(localeDe)


@Injectable()
export class SentryErrorHandler implements ErrorHandler {

    constructor(
        private platform: Platform
    ) {
    }


    handleError(error: any) {
        console.error(error)
        const platforms = this.platform.platforms() || null
        if (!!platforms) {
            sentry.setTag("platform", platforms.join(", "))
        }
        sentry.captureException(error.originalError || error)
    }
}


const providers: Provider[] = [
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    {provide: LOCALE_ID, useValue: "de-DE"},
]


// Sentry initialisieren
function initSentry() {

    if ("glitchTip" in environment) {

        // Initialisieren
        sentry.init({
            dsn: environment.glitchTip["dsn"],
            release: `${environment.build}-${environment.version}`,
            attachStacktrace: true,
            maxValueLength: 2000,
            maxBreadcrumbs: 10,
            tracesSampleRate: environment.glitchTip["tracesSampleRate"],
            ignoreErrors: ["ChunkLoadError"]
        })

        // ErrorHandler hinzufügen
        providers.push({provide: ErrorHandler, useClass: SentryErrorHandler},)

    }
}


initSentry()


// Globale Objekte erstellen, auf die später zugegriffen werden kann
function initGlobal() {
    window["userId"] = getUserId()
}


initGlobal()


export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(
            IonicModule.forRoot({
                backButtonText: ""
            }),
            ServiceWorkerModule.register("ngsw-worker.js", {
                enabled: environment.serviceWorker,
                // Register the ServiceWorker as soon as the app is stable
                // or after 10 seconds (whichever comes first).
                registrationStrategy: 'registerWhenStable:10000'
            }),
        ),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        ...providers,
        provideHttpClient()
    ]
}